import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-i18n-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import { Translator, TextHook as Text } from "./components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Translator heading page="basicUsageHook" num="0" mdxType="Translator" />
    <Translator page="basicUsageHook" num="0" mdxType="Translator" />
    <Translator page="basicUsageHook" num="1" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// ./i18n/index.js
const data = {
  de: {
    text: "Hallo Welt!",
  },
  en: {
    text: "Hello World!",
  },
};

export { data };
`}</code></pre>
    <Translator page="basicUsageHook" num="2" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { useI18n } from "react-i18n-kit";

import { data } from "./i18n";

/*
  if language is:
    - en:
      i18n.text: "Hello World!"
    - de:
      i18n.text: "Hallo Welt!"
*/
const Text = () => {
  const { i18n } = useI18n(data)

  return (
    <div>{i18n.text}</div>
  );
};

export { Text };
`}</code></pre>
    <Translator page="basicUsageHook" num="3" mdxType="Translator" />
    <Playground __position={5} __code={'<Text />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Translator,
      Text
    }} mdxType="Playground">
  <Text mdxType="Text" />
    </Playground>
    <Translator page="basicUsageHook" num="4" mdxType="Translator" />
    <Translator page="basicUsageHook" num="5" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "text": "Hello World!"
}
`}</code></pre>
    <Translator page="basicUsageHook" num="6" mdxType="Translator" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      